// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fNbCsx5NXH7A6uZGaSk9 {
	border-radius: 32px;
	background-color: var(--white);
	box-shadow: 0 25px 30px rgba(0, 0, 0, 0.15);
}
.d9uzAI4DICnL0DELLTXR {
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 32px;
}
.HTDNPt1j_IbOKrHuy2gT:first-child {
	}
.HTDNPt1j_IbOKrHuy2gT:last-child {
		border-radius: 0 0 32px 32px;
	}
@media (max-width: 767px) {
.HTDNPt1j_IbOKrHuy2gT:last-child {
			border-radius: 0;
	}
		}
.XQqs6pv9pJWwdw6tiikv {
	padding: 18px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04) inset;
}
.s3VOgXriGkbpq4PwDSfE {
	display: flex;
	overflow: hidden;

	/* HACK: Not the best solution, but it will do for now. */
}
.s3VOgXriGkbpq4PwDSfE > button {
		height: 75px;
		border-radius: 0;
	}
`, "",{"version":3,"sources":["webpack://./src/components/Tile/Tile.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,2CAA2C;AAC5C;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;AACd;AAGC;CACA;AACA;EACC,4BAA4B;CAI7B;AAHC;AAFD;GAGE,gBAAgB;CAElB;EADC;AAIF;CACC,aAAa;CACb,gDAAgD;AACjD;AAEA;CACC,aAAa;CACb,gBAAgB;;CAEhB,yDAAyD;AAK1D;AAJC;EACC,YAAY;EACZ,gBAAgB;CACjB","sourcesContent":["@import '../../stylesheets/media-queries.pcss';\n\n.tile {\n\tborder-radius: 32px;\n\tbackground-color: var(--white);\n\tbox-shadow: 0 25px 30px rgba(0, 0, 0, 0.15);\n}\n\n.header {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 20px;\n\tpadding: 32px;\n}\n\n.item {\n\t&:first-child {\n\t}\n\t&:last-child {\n\t\tborder-radius: 0 0 32px 32px;\n\t\t@media (--mobile) {\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n}\n\n.inner {\n\tpadding: 18px;\n\tbox-shadow: 0 4px 16px rgba(0, 0, 0, 0.04) inset;\n}\n\n.footer {\n\tdisplay: flex;\n\toverflow: hidden;\n\n\t/* HACK: Not the best solution, but it will do for now. */\n\t& > button {\n\t\theight: 75px;\n\t\tborder-radius: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `fNbCsx5NXH7A6uZGaSk9`,
	"header": `d9uzAI4DICnL0DELLTXR`,
	"item": `HTDNPt1j_IbOKrHuy2gT`,
	"inner": `XQqs6pv9pJWwdw6tiikv`,
	"footer": `s3VOgXriGkbpq4PwDSfE`
};
export default ___CSS_LOADER_EXPORT___;
